import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WPQTPageHeader } from "../components/common/Header/Header";
import { Page } from "./Page/Page";
function OverviewPage() {
    return (_jsxs(Page, { children: [_jsx(WPQTPageHeader, { children: "Overview" }), _jsx("p", { children: "This is the overview page." })] }));
}
export { OverviewPage };
